import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';

import { useContinueLoginWithSessionToken } from './useContinueLoginWithSessionToken';
import { useInitialLoginAndSessionValidation } from './useInitialLoginAndSessionValidation';

/* core, added Promise.reject(error) (line 22) and added return userData (line 18) */
export const useLoginByCredentials = () => {
    const continueLoginWithSessionToken = useContinueLoginWithSessionToken();
    const initialLoginAndSessionValidation = useInitialLoginAndSessionValidation();

    return useCallback(async (userName, password, rememberMeLogin = false, afterRegisterLogin = false, loginMode) => {
        try {
            const credentials = await initialLoginAndSessionValidation(
                userName, password, rememberMeLogin, afterRegisterLogin, loginMode
            );

            return await continueLoginWithSessionToken({ ...credentials, afterRegisterLogin, isAfterLoginWithCredentials: true });
        } catch (error) {
            dispatcher.dispatch('auth:credentials:login:failed', error);

            return Promise.reject(error);
        }
    }, [initialLoginAndSessionValidation, continueLoginWithSessionToken]);
};
